import providers from '@/providers';
import { State } from '@/views/login/store/state.store';

export default {
  getLoginFormErrors(state: State): string {
    return state.loginForm.errors?.length
      ? providers.i18n?.t(`vLogin.form.errors.${state.loginForm.errors}`)
      .toString() || ''
      : '';
  },
};
